import { useEffect, useState } from "react";
import { Card, CardBody, Col, Row, Table } from "reactstrap";
import contratoService from "services/ContratoService";
import Item from "./item";
import PercentualComAlerta from "components/PercentualComAlerta";

export default function SaldoItens({ dados }) {
  return (
    <Card className="mt-4 dashboard-saldo-itens">
      <CardBody>
        <div className="text-center mb-4">
          <div><strong>Total Previsto:</strong> R$ {dados.valorPrevistoFmt}</div>
        </div>
        <div className="d-flex justify-content-center flex-wrap mb-4" style={{ gap: 20 }}>
          <div><strong>Total Distribuido:</strong> R$ {dados.valorDistribuidoFmt}</div>
          <div><strong>Saldo Distribuição:</strong> R$ {dados.saldoValorDistribuidoFmt}</div>
          <div><strong>% Distribuído:</strong> <PercentualComAlerta valor={dados.percentualValorDistribuido} /></div>
        </div>
        <div className="d-flex justify-content-center flex-wrap mb-4" style={{ gap: 20 }}>
          <div><strong>Total Executado:</strong> R$ {dados.valorExecutadoFmt}</div>
          <div><strong>Saldo Execução:</strong> R$ {dados.saldoValorExecutadoFmt}</div>
          <div><strong>% Executado:</strong> <PercentualComAlerta valor={dados.percentualValorExecutado} /></div>
        </div>
        <div className="dashboard-table-scroll">
          <Table className="align-items-center table-flush dashboard-wide-table">
            <thead>
              <tr>
                <th>Item</th>
                <th>Descrição</th>
                <th className="text-right">Valor Previsto</th>
                <th className="text-right">Valor Distribuido</th>
                <th className="text-right">Saldo Distribuição</th>
                <th className="text-right">% Distribuído</th>
                <th className="text-right">Valor Executado</th>
                <th className="text-right">Saldo Execução</th>
                <th className="text-right">% Executado</th>
                <th style={{ width: 5 }}></th>
              </tr>
            </thead>
            <tbody>
              {dados.itens.map(el => <Item key={el.id} {...el} />)}
            </tbody>
          </Table>
        </div>
      </CardBody>
    </Card>
  )
}
